import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Pagination } from '@core/models/pagination.model';
import { BotStatus } from '@core/models/bot-status.model';

@Injectable()
export class BotStatusDataService extends DefaultDataService<BotStatus> {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
      super('BotStatus', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<BotStatus[]> {
    return this.http.get<ApiResponse>('/banksys/bankstatus').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<BotStatus[]>{
    return this.http.get<ApiResponse>(`/banksys/bankstatus${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getBankBotServer() {
     return this.http.get<ApiResponse>('/banksys/bankbotserver').pipe(
      map(res => res.data.rows)
    );
  }

  getBankBotStage() {
     return this.http.get<ApiResponse>('/banksys/bankbotstage').pipe(
      map(res => res.data.rows)
    );
  } 

  updateSwitch(id: number, param: any) {
    return this.http.put<ApiResponse>(`/banksys/${id}`, param).pipe(
      tap(res =>  this.messages$.next(res.message))
    );
  } 
  
  updateTAC(data: any) {
    return this.http.post<ApiResponse>(`/banksys/updatetac`, data).pipe(
      tap(res =>  this.messages$.next(res.message))
    );
  }

  createReconJob(data: any) {
    return this.http.post<ApiResponse>(`/banksys/createreconjob`, data).pipe(
      tap(res =>  this.messages$.next(res.message))
    );
  }

  getBankTransactionList(id: number) {
     return this.http.get<ApiResponse>(`/banksys/bank-transaction-list/${id}`).pipe(
      map(res => res.data)
    );
  } 

  private paginationInit(res: any) {
    if(res) {
      this.pagination = res.data.paginations;
    }
  }

}
